import { isString } from 'lodash';
import { Children, PropsWithChildren } from 'react';
import { Text } from '~/components/typography';
import { StyledText, StyledSection } from './dialog.style';

const SectionTitle = ({ children }: PropsWithChildren<{}>) => (
  <Text textStyle="heading500" mb={4} tag="h3">
    {children}
  </Text>
);

type DialogSectionProps = PropsWithChildren<{
  title?: string;
}>;

export const DialogSection = ({ children, title }: DialogSectionProps) => (
  <StyledSection>
    {title && <SectionTitle>{title}</SectionTitle>}
    {Children.map(children, child => {
      if (isString(child)) return <StyledText key={child}>{child}</StyledText>;
      return child;
    })}
  </StyledSection>
);
